﻿import { tns } from 'tiny-slider/src/tiny-slider.js';

var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
    }
};

var sliderlists = document.querySelectorAll('.slider-list-container');

forEach(sliderlists, function (index, value) {
    tns({
        container: value.querySelector('.slider-list'),
        speed: 500,
        items: 1,
        slideBy: 1,
        center: true,
        gutter: 20,
        prevButton: value.querySelector('.tns-button-prev'),
        nextButton: value.querySelector('.tns-button-next'),
        mouseDrag: true,
        nav: false,
        responsive: {
            768: {
                items: 2,
                center: false,
            },
            1024: {
                items: 3,
                center: false
            }
        },
        onInit: (ts) => {
            ts.nextButton.setAttribute('tabindex', 0);
            ts.prevButton.setAttribute('tabindex', 0);
        }
    });
});